import header from './header';
import footer from './footer';
import logos from './logos';

export default [header, footer, logos];
